module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/shin-c241f18d3a2fbadffa6dd1121441b622.svg";